import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotAuthGuard } from '@auth/not-auth.guard';
import { ErrorPageComponent } from './core/pages/error-page/error-page.component';
import { ConfigsResolver } from './core/resolvers/configs/configs.resolver';
import { ProviderConfigErrorComponent } from './provider/pages/provider-config-error/provider-config-error.component';
import { providerConfigGuard } from './provider/provider-config.guard';
import { PaymentPlanInitPageComponent } from './rp/sms-journey/payment-plan-init-page/payment-plan-init-page.component';

const routes: Routes = [
  {
    path: 's/:code',
    loadComponent: () =>
      import('./redirect/pages/redirect/redirect.component').then(c => c.RedirectComponent)
  },
  { path: 'error/:code', component: ErrorPageComponent },
  {
    path: '',
    resolve: {
      config: ConfigsResolver
    },
    children: [
      {
        path: 'login',
        loadChildren: () => import('./login/pages/login.routes').then(r => r.LOGIN_ROUTES),
        canActivate: [NotAuthGuard]
      },
      {
        path: 'amendment/confirmation',
        loadChildren: () =>
          import('./rp/amendment-confirm/amendment-confirm.module').then(
            m => m.AmendmentConfirmModule
          )
      },
      {
        path: 'payment-plan-init',
        component: PaymentPlanInitPageComponent,
        data: { wrapperClass: 'dark-screen' }
      },
      {
        path: 'missed-payments-paynow',
        loadChildren: () => import('./rp/paynow/paynow.module').then(m => m.PaynowModule),
        data: { hideMenu: true, wrapperClass: 'white-screen' }
      },
      {
        path: 'payment-sms-journey',
        loadChildren: () =>
          import('./rp/sms-journey/sms-journey.module').then(m => m.SmsJourneyModule),
        data: { wrapperClass: 'dark-screen' }
      },
      {
        path: 'treatment-proposal',
        loadChildren: () =>
          import('./rp/treatment-proposal/treatment-proposal.module').then(
            m => m.TreatmentProposalModule
          ),
        data: { wrapperClass: 'white-screen' }
      },
      {
        path: 'external',
        loadChildren: () => import('./external/external.module').then(m => m.ExternalModule)
      },
      {
        path: 'provider-config-error',
        component: ProviderConfigErrorComponent
      },
      // must stay LAST: empty-path + canMatch runs for any URL that reaches it
      {
        path: '',
        canMatch: [providerConfigGuard],
        loadChildren: () => import('./provider/provider.module').then(m => m.ProviderModule)
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'error/404',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled' // lets links like /page#section scroll to that element
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
